module.exports = __webpack_public_path__ + "static/media/ic-popup-close.6badccba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-popup-close.svg
// module id = 101
// module chunks = 0